// Random identifiers, encodings and room ids.

export function randomBytes(n: number): Uint8Array<ArrayBuffer> {
  return crypto.getRandomValues(new Uint8Array(n));
}

export function toHex(bytes: Uint8Array): string {
  return [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
}

export function randomHex(n: number): string {
  return toHex(randomBytes(n));
}

export function b64url(bytes: Uint8Array): string {
  let bin = '';
  for (const b of bytes) bin += String.fromCharCode(b);
  return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

export function fromB64url(text: string): Uint8Array<ArrayBuffer> {
  const bin = atob(text.replace(/-/g, '+').replace(/_/g, '/'));
  return Uint8Array.from(bin, (c) => c.charCodeAt(0));
}

/** 128-bit secret for a share link. It only ever lives in the link's fragment. */
export function randomSecret(): string {
  return b64url(randomBytes(16));
}

export const SECRET = /^[A-Za-z0-9_-]{22}$/;

export async function sha256Hex(text: string): Promise<string> {
  return toHex(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text))));
}

/** What the server sees of a share link: a hash it cannot invert. */
export function roomIdFor(secret: string): Promise<string> {
  return sha256Hex(`drop-room-v1:${secret}`);
}
